import { useRef } from "react";
import { HeaderHome } from "../../components/headers/HeaderHome";
import { Mission } from "../../components/mission/Mission";
import { PourOut } from "../../components/events/PourOut";
import { Contact } from "../../components/contact/Contact";

export function Home() {
    /** Main Navigation Refs */
    const missionRef = useRef(null);
    const scrollToMission = () => missionRef.current?.scrollIntoView({behavior: 'smooth'});
    const eventsRef = useRef(null);
    const scrollToEvents = () => eventsRef.current?.scrollIntoView({behavior: 'smooth'});
    const contactRef = useRef(null);
    const scrollToContact = () => contactRef.current?.scrollIntoView({behavior: 'smooth'});

    return (
        <>
            <HeaderHome scrollHandlers={{
                'mission': scrollToMission,
                'events': scrollToEvents,
                'contact': scrollToContact
            }} />
            <main>
                <Mission scrollRef={missionRef}  />
                <section ref={eventsRef} id="events">
                    <PourOut />
                </section>
                <Contact scrollRef={contactRef}  />
            </main>
        </>     
    );
  }